











































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import InformationCard from "@/components/InformationCard.vue";
import InformationCardValues from "@/components/InformationCardValues.vue";
import moment from "moment";
import {
  ReferralEspoedDetailsModel,
  AmbuFeedbackMessageLogModel,
} from "@/types/aznconnect_api";

@Component({
  components: {
    "information-card": InformationCard,
    "information-card-values": InformationCardValues,
  },
})
export default class DetailPane extends Vue {
  formatDate = Vue.filter("formatDate");
  formatDateTime = Vue.filter("formatDateTime");
  formatGender = Vue.filter("formatGender");

  @Prop({ default: null })
  referral!: ReferralEspoedDetailsModel;

  //@Prop({ default: null })
  model!: AmbuFeedbackMessageLogModel;

  @Watch("referral", { immediate: true }) onPropChanged(
    value: ReferralEspoedDetailsModel,
    oldValue: ReferralEspoedDetailsModel,
  ) {
    this.model = this.referral.AmbuFeedbackMessageLogs[0];
  }

  private navigateToAmbulanceFeedbackMessage(
    ambuFeedbackMessageLogModel: AmbuFeedbackMessageLogModel,
  ) {
    this.model = ambuFeedbackMessageLogModel;
    this.$forceUpdate();
  }
}
